import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/services/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AwsRedHomeService {

  constructor(
    private http: HttpClient, 
    private sessionService: SessionService
  ) { }

  //// nuevo backend
  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    })
  };

  ////TOPBAR

  //Detalle registro personalizado
  customRegistration(){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/topBar/myCompanies`,{}, this.httpOptionsNew);
  }

  //REGISTRO EMPRESA
  
  //Empresas no aprobadas
  unapprovedCompanies(){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/companyRegistration/unapprovedCompanies`,{}, this.httpOptionsNew);
  }

  //CONTENIDO PRINCIPAL

  //Tiendas destacadas
  companyStore(body){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/mainContent/companyStore`,body, this.httpOptionsNew);
  }

  //Publicaciones empresas  
  companyPosts(body){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/mainContent/companyPosts`,body, this.httpOptionsNew);
  }

  //Completar datos
  followSteps(body){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/mainContent/followSteps`,body, this.httpOptionsNew);
  }
}

